import React from 'react';
import RecipePasta from '../../components/RecipePasta';

const Pasta = () => {
  return (
    <div className="home-page">
      <RecipePasta/>
    </div>
  );
};

export default Pasta;